import React from 'react';
// components
import FilesTable from './FilesTable';
import { DocumentTypesControl, UsersControl, UploadedOnControl, PinnedOnlyControl } from './components';
import { isNil } from 'lodash';

const formatSearchParams = ({ createdBy, uploadedOn, ...rest }) => {
  const filters = {
    ...rest,
    createdBy: typeof createdBy === 'object' ? createdBy?.userName : createdBy,
  };

  if (!isNil(uploadedOn?.start)) {
    const dateFrom = new Date(uploadedOn?.start);
    dateFrom.setHours(0, 0, 0, 0);

    filters.dateFrom = dateFrom.toISOString();
  } else {
    filters.dateFrom = null;
  }

  if (!isNil(uploadedOn?.end)) {
    const dateTo = new Date(uploadedOn?.end);
    dateTo.setHours(23, 59, 59, 999);

    filters.dateTo = dateTo.toISOString();
  } else {
    filters.dateTo = null;
  }
  return filters;
};

const AttachmentsGrid = ({ id, disabled, readOnly, showDriverDoc, afterSave, ...props }) => (
  <section className="card-fluid uploads-card">
    <legend className="card-title">Uploaded files</legend>
    <FilesTable
      id={id}
      disabled={disabled}
      readOnly={readOnly}
      showDriverDoc={showDriverDoc}
      afterSave={afterSave}
      formatSearchParams={formatSearchParams}
      {...props}
      filterFields={[
        {
          name: 'fileTypes',
          label: 'Document types',
          Component: DocumentTypesControl,
        },
        {
          name: 'createdBy',
          label: 'Uploaded by',
          Component: UsersControl,
        },
        {
          name: 'uploadedOn',
          Component: UploadedOnControl,
          isFloatingLabel: false,
        },
        {
          name: 'pinnedOnly',
          label: 'Pinned only',
          Component: PinnedOnlyControl,
          isFloatingLabel: false,
        },
        ...(props.filterFields ?? []),
      ]}
      
    />
  </section>
);
export default AttachmentsGrid;
